/**
 Author - Muhamed Afsal
 Git - https://bitbucket.org/mohdafsal/
 **/

import Newsletter from "./Newsletter";

export default Newsletter;
